import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  TemplateRef
} from '@angular/core';
import { DataSharingService } from '../../AuthGuard/DataSharingService';
import { DialogService } from "../../Shared/dialog.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import * as XLSX from 'xlsx';
import { MatTableDataSource } from "@angular/material/table";
import { PartnerService } from "../services/partner.service";
import { MatDialog } from '@angular/material/dialog';
import * as FileSaver from "file-saver";

@Component({
  selector: 'app-partner-amortization',
  templateUrl: './partner-amortization.component.html',
  styleUrls: ['./partner-amortization.component.scss']
})
export class PartnerAmortizationComponent implements OnInit {
  currentUser: any;
  showSpinner = false;
  tab: any;
  dataSource: any;
  PLoan_Date:any;
  message: "";
  previewDataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    "Period", "DueDate", "EMI_Amount", "Principle", "Interest", "Outstanding_Principle",
  ];
  previewColumns: string[] = ["Period", "EMI_Amount", "Principle", "Interest", "Outstanding_Principle"];


  @Input() loanSummary: any;
  @Input() PageType: any;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  Partner_LoanId: any;
  amortizationListList: any[] = [];
  importPeriodMismatch: boolean = false;
  ShowImportAmortization: boolean = false;
  isValidData = false;
  validationErrorMessage = '';
  Data_FreezeDate;
  @ViewChild('previewModal') previewModal!: TemplateRef<any>;

  configSuccess: MatSnackBarConfig = {
    panelClass: 'style-success',
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };
  // snackBar: any;

  constructor(
    private dataSharingService: DataSharingService,
    private dialog: DialogService,
    private snackBar: MatSnackBar,
    private _Partnerservice: PartnerService,
    public matDialog: MatDialog
  ) {}

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next('Amortization Chart');
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    this.Partner_LoanId = sessionStorage.getItem('Partner_LoanId');
    this.Data_FreezeDate = new Date(this.currentUser.Data_Freeze.split('T')[0]);
    
    this.Get_Amortization_Chart();

    if (!this.Partner_LoanId && this.loanSummary?.LoanId) {
      this._Partnerservice.Partner_Get_Existing_Loan_Details({ LoanId: this.loanSummary.LoanId }).subscribe((res: any) => {
        this.Partner_LoanId = res[0]?.Partner_LoanId;
        this.Get_Amortization_Chart();
      });
    }

    this.tab = 'plist';
  }

  Get_Amortization_Chart() {
    this._Partnerservice.Partner_Get_Amortization_Chart({ LoanId: this.Partner_LoanId }).subscribe((res: any) => {
      if(res.length>0){
      this.amortizationListList = res;
      this.dataSource = new MatTableDataSource(res);
      this.PLoan_Date=res[0].PLoan_Date
      this.getTotal();
      if (new Date(this.PLoan_Date)> this.Data_FreezeDate) {
        this.ShowImportAmortization=true;
      }
      }
      this.showSpinner = false;
    });
  }

  getTotal() {
    let emiTotal = 0, principleTotal = 0, interestTotal = 0;
    this.amortizationListList.forEach((obj: any) => {
      emiTotal += +obj.EMI_Amount || 0;
      principleTotal += +obj.Principle || 0;
      interestTotal += +obj.Interest || 0;
    });

    if (this.amortizationListList.length > 0) {
      this.amortizationListList.push({
        DueDate: "Total",
        EMI_Amount: emiTotal,
        Principle: principleTotal,
        Interest: interestTotal,
        isBold: true
      });
    }
  }

  changeTabList(tab: any) {
    this.tab = tab;
  }

  onNextStep() {
    this.action.emit("next");
  }

  exportTable(exporter: any) {
    exporter.exportTable('xls', {
      fileName: `partner-amortization-list`,
      sheet: 'partner-amortization-list'
    });
  }

  ImportAmortizationData(event: any) {
    this.message = "";
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length !== 1) {
      console.error('Please upload only one file.');
      return;
    }
  
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const arrayBuffer: ArrayBuffer = e.target.result;
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
  
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const data: any[] = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
  
      const cleaned = data.map((row: any) => {
        const validateAndKeep = (key: string): { value: any, invalid: boolean } => {
          const val = row[key];
          const num = +val;
          const isInvalid = isNaN(num);
          return {
            value: isInvalid ? val : num,
            invalid: isInvalid
          };
        };
  
        const emi = validateAndKeep('EMI_Amount');
        const principle = validateAndKeep('Principle');
        const interest = validateAndKeep('Interest');
        const outstanding = validateAndKeep('Outstanding_Principle');
  
        const interestGtPrinciple = false; // or remove the check entirely
  
        return {
          Period: row['Period'],
          DueDate: row['Due Date'],
          EMI_Amount: emi.value,
          Principle: principle.value,
          Interest: interest.value,
          Outstanding_Principle: outstanding.value,
          invalidCells: {
            EMI_Amount: emi.invalid,
            Principle: principle.invalid,
            Interest: interest.invalid,
            Outstanding_Principle: outstanding.invalid
          }
        };
      });
  
      // Validate overall
      const isEveryRowValid = cleaned.every(row =>
        !Object.values(row.invalidCells).some(v => v === true)
      );
      this.importPeriodMismatch = cleaned.length !== this.amortizationListList.length - 1;
  
      this.validationErrorMessage = '';
      if (this.importPeriodMismatch) {
        this.validationErrorMessage = `The number of periods must be ${this.amortizationListList.length - 1}.`;
      }
  
      this.previewDataSource.data = cleaned;
      this.isValidData = isEveryRowValid && !this.importPeriodMismatch;
  
      this.matDialog.open(this.previewModal, { width: '80%' });
  
      input.value = ''; // Reset file input so same file can be selected again
    };
  
    reader.readAsArrayBuffer(input.files[0]);
  }
  

  applyPreviewData() {
    const payload = {
      JSON: JSON.stringify(this.previewDataSource.data),
      Partner_LoanId: Number(this.Partner_LoanId),
      LoginUserId: this.currentUser?.userId
    };
    

    
    this.showSpinner = true;
    this._Partnerservice.Partner_Save_Import_Amortization(payload).subscribe({
      next: (res: any[]) => {
        this.showSpinner = false;
        this.message = "";
        // Check if the response contains data and loop through it
        if (res && res.length > 0) {
          res.forEach((item) => {
            switch (item.CODE) {
              case 0:
                // Success case
                this.snackBar.open(item.MSG, '', this.configSuccess);
                this.matDialog.closeAll();
                this.Get_Amortization_Chart(); // Refresh table
                break;
  
              case -1:
                // Specific message for CODE -1
                this.snackBar.open(item.MSG, '', this.configSuccess);
                // this.matDialog.closeAll();
                this.Get_Amortization_Chart();
                break;
  
              default:
                // Handle unknown or other error codes
                this.snackBar.open(`Error: ${item.MSG}`, '', {
                  ...this.configSuccess,
                  panelClass: 'style-error'
                });
                break;
            }
            this.message = (item.MSG)
            console.log(this.message);
            
          });
        } else {
          // Handle if the response is empty or invalid
          this.snackBar.open('Invalid response from server.', '', {
            ...this.configSuccess,
            panelClass: 'style-error'
          });
        }
      },
      error: (err) => {
        this.showSpinner = false;
        // Display error message if API call fails
        this.snackBar.open('Something went wrong. Please try again.', '', {
          ...this.configSuccess,
          panelClass: 'style-error'
        });
      }
    });
  }
  ExportAmortizationTemplate(){
    const headers = [
      "Period",
      "EMI_Amount",
      "Principle",
      "Interest",
      "Outstanding_Principle",
    ];
  
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([headers]);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveAsExcelFile(excelBuffer, 'Partener_Amortization_Template');
  }
  
  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/octet-stream',
    });
    FileSaver.saveAs(data, `${fileName}.xlsx`);
  }
  
}
